import { pdfjs } from 'react-pdf'

pdfjs.GlobalWorkerOptions.workerSrc = '/webWorkers/pdf.worker.min.js'
